export default [
  {
    path: '/servidores',
    name: 'servidores',
    component: () => import(/* webpackChunkName: "servidores" */ '@/pages/servidores/ServidoresPage.vue'),
    meta: { requiresAuth: true },
  },
]
